import { render, staticRenderFns } from "./WhatsAppList.vue?vue&type=template&id=05db57d2&scoped=true&"
import script from "./WhatsAppList.vue?vue&type=script&lang=js&"
export * from "./WhatsAppList.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppList.vue?vue&type=style&index=0&id=05db57d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db57d2",
  null
  
)

export default component.exports